import { Button, DatePicker, Form, Input, InputNumber, Select } from 'antd';
import type { FormListFieldData } from 'antd/es/form';
import { Dayjs } from 'dayjs';
import { Trash2 } from 'lucide-react';
import { PaymentRecord } from './entry.types';

export function getPaymentTableColumns(remove: (index: number) => void) {
  return (_fields: FormListFieldData[]) => [
    {
      title: '#',
      dataIndex: 'key',
      key: 'key',
      width: 50,
      render: (_: number | undefined, _record: PaymentRecord, index: number) => <b>{index + 1}</b>,
    },
    {
      title: 'Ngày thanh toán',
      dataIndex: 'date',
      key: 'date',
      width: 150,
      render: (_: Dayjs, _record: PaymentRecord, index: number) => (
        <Form.Item name={[index, 'date']} noStyle>
          <DatePicker placeholder="" style={{ width: '100%' }} format="DD/MM/YYYY" />
        </Form.Item>
      ),
    },
    {
      title: 'Hình thức thanh toán',
      dataIndex: 'method',
      key: 'method',
      width: 200,
      render: (_: string, _record: PaymentRecord, index: number) => (
        <>
          <Form.Item name={[index, 'method']} noStyle>
            <Select placeholder="" style={{ width: '100%' }} popupMatchSelectWidth={false}>
              <Select.Option value="company">Chuyển khoản tài khoản công ty</Select.Option>
              <Select.Option value="personal">Chuyển khoản tài khoản cá nhân</Select.Option>
              <Select.Option value="ktv">KTV / thợ thu COD </Select.Option>
              <Select.Option value="mpos">mPOS</Select.Option>
              <Select.Option value="gtkt">GTKT/ GHN/ ViettelPost/ Nhất Tín/J&T thu hộ</Select.Option>
              <Select.Option value="ahamove">AhaMove/ Grab thu hộ </Select.Option>
              <Select.Option value="shopee">Shopee</Select.Option>
              <Select.Option value="cash">Thanh toán tiền mặt tại cửa hàng </Select.Option>
              <Select.Option value="hdsaison">Trả góp HDSaison</Select.Option>
              <Select.Option value="other">Khác</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item
            noStyle
            shouldUpdate={(prev, curr) => prev?.payments?.[index]?.method !== curr?.payments?.[index]?.method}
          >
            {({ getFieldValue }) => {
              const method = getFieldValue(['payments', index, 'method']);
              if (method === 'other') {
                return (
                  <Form.Item name={[index, 'note']} className="mt-[16px]">
                    <Input placeholder="Nhập phương thức khác..." className="w-full" />
                  </Form.Item>
                );
              }
              return null;
            }}
          </Form.Item>
        </>
      ),
    },
    {
      title: 'Giá trị thanh toán',
      dataIndex: 'amount',
      key: 'amount',
      width: 150,
      render: (_: number, _record: PaymentRecord, index: number) => (
        <Form.Item name={[index, 'amount']} noStyle>
          <InputNumber
            style={{ width: '100%' }}
            formatter={(value?: number | string) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
            parser={(value?: string | undefined) => (value ? value.replace(/\$\s?|(,*)/g, '') : 0)}
          />
        </Form.Item>
      ),
    },
    {
      title: '',
      key: 'action',
      width: 50,
      render: (_: any, _record: PaymentRecord, index: number) => (
        <Button type="text" icon={<Trash2 color="red" />} onClick={() => remove(index)} />
      ),
    },
  ];
}
